import axios from "../config/axios-config";

const options = (language, signal) => ({headers: {"Language-Context": language.toUpperCase()}, signal});
export const fetchNotifications = async ({page, size, read, search}, language, signal) =>
    (await axios.get("/api/v1/notifications", {...options(language, signal), params: {page, size, read, search}})).data;
export const fetchUnreadCount = async (language, signal) =>
    (await axios.get("/api/v1/notifications/read-state", {...options(language, signal), params: {read: false}})).data;
export const markNotificationRead = async (id, language) =>
    (await axios.put(`/api/v1/notifications/${encodeURIComponent(id)}/read`, {}, options(language))).data;
export const markAllNotificationsRead = async language =>
    (await axios.put("/api/v1/notifications/read-all", {}, options(language))).data;
